import {
	calculateNextTripRequest,
} from '../../requests';

import deepCopy from 'deepcopy';

const setAutoSchedule = ({ commit, dispatch }, value) => {
	commit('setDetails', { path: 'autoSchedule', value });
	dispatch('findNextTrip');
};

const setFrequencyType = ({ commit, dispatch }, value) => {
	commit('setFrequency', { path: 'type', value });
	dispatch('findNextTrip');
};

const setFrequencyStartDate = ({ commit, dispatch }, value) => {
	commit('setFrequency', { path: 'startDate', value });
	dispatch('findNextTrip');
};

const setFrequencyEndDate = ({ commit, dispatch }, value) => {
	commit('setFrequency', { path: 'endDate', value });
	dispatch('findNextTrip');
};

const setFrequencyWeekly = ({ commit, dispatch }, { day, value }) => {
	commit('setFrequency', { path: `weekly.${day}`, value });
	dispatch('findNextTrip');
};

const setFrequencyTwoWeekly = ({ commit, dispatch }, { week, day, value }) => {
	commit('setFrequency', { path: `twoWeekly.${week}.${day}`, value });
	dispatch('findNextTrip');
};

const setFrequencyMonthly = ({ commit, dispatch }, { id, key, value }) => {
	commit('setFrequency', { path: `monthly.${id}.${key}`, value });
	dispatch('findNextTrip');
};

const setFrequencySpecificDates = ({ commit, dispatch }, { id, value }) => {
	commit('setFrequency', { path: `specificDates.${id}`, value });
	dispatch('findNextTrip');
};


const addFrequencyDay = ({ state, commit, dispatch }, ) => {
	let newDay = null;
	if (state.templateDetails.frequency.type === 'monthly') {
		newDay = {
			number: 1,
			day: 'monday'
		};
	} else if (state.templateDetails.frequency.type === 'specificDates' ) {
		newDay = '';
	}
	if (newDay) {
		// state.templateDetails.frequency[state.templateDetails.frequency.type].push(newDay);
		commit('setFrequency', { path: `${state.templateDetails.frequency.type}.${state.templateDetails.frequency.type.length}`, value: newDay });
	}
	dispatch('findNextTrip');
};

const removeFrequencyDay = ({ state, commit, dispatch }, id) => {
	let clone = deepCopy(state.templateDetails.frequency[state.templateDetails.frequency.type]);
	clone.splice(id, 1);

	// state.templateDetails.frequency[state.templateDetails.frequency.type] = clone;
	commit('setFrequency', { path: state.templateDetails.frequency.type, value: clone });
	dispatch('findNextTrip');
};

const findNextTrip = async({ state, commit }) => {
	try {
		let nextTrip = await calculateNextTripRequest(state.templateDetails);
		commit('setNextTrip', nextTrip);
	} catch (err) {
		throw new Error('failedToCalculate');
	}
};

export default {
	setAutoSchedule,
	setFrequencyType,
	setFrequencyStartDate,
	setFrequencyEndDate,
	setFrequencyWeekly,
	setFrequencyTwoWeekly,
	setFrequencyMonthly,
	setFrequencySpecificDates,
	addFrequencyDay,
	removeFrequencyDay,
	findNextTrip,
};
